var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "eem Logo",
    viewBox: "0 0 55.504 49.092",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eem-logo-1{fill:#fff}.eem-logo-2{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 22501"
  }, /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-1",
    transform: "translate(13.515 36.705)",
    d: "M8.295 3.611A9.913 9.913 0 0 1 .849.479C.708.325.583.161.453 0A9.094 9.094 0 0 0 0 2.9v9.489h6.229c4.547 0 7.286-2.468 7.286-7.994v-.784z",
    "data-name": "Fill 1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-2",
    transform: "translate(.001 13.329)",
    d: "M0 0v22.686h30.433V0z",
    "data-name": "Clip 4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-1",
    transform: "translate(0 13.329)",
    d: "M13.391 22.686h-1.067c-4.14 0-7.288-1.055-9.357-3.135C1 17.571 0 14.66 0 10.9V0h19.993a13.772 13.772 0 0 1 3.77.5 10.423 10.423 0 0 1 3.167 1.487 8.356 8.356 0 0 1 3.5 5.752 5.548 5.548 0 0 1-.129.165 4.585 4.585 0 0 0-.195.258 9.3 9.3 0 0 0-.8-1.07 8.811 8.811 0 0 0-3.237-2.318A11 11 0 0 0 21.845 4a10.746 10.746 0 0 0-4.213.8 9.189 9.189 0 0 0-3.291 2.386 10.846 10.846 0 0 0-2.107 3.714 14.947 14.947 0 0 0-.7 4.715A15.184 15.184 0 0 0 12 19.484a11.179 11.179 0 0 0 1.391 3.2zm16.5-.032h-8.035a5.508 5.508 0 0 1-1.9-.45A4.929 4.929 0 0 1 18.4 21.1a6.8 6.8 0 0 1-1.712-4.309h11.4a12.265 12.265 0 0 0 1.8 5.86zm-2.955-10.012h-9.918a6.044 6.044 0 0 1 .7-1.693 5.115 5.115 0 0 1 1.108-1.274 4.812 4.812 0 0 1 1.437-.812 5.008 5.008 0 0 1 1.69-.283 4.953 4.953 0 0 1 3.222 1.02 5.572 5.572 0 0 1 1.761 3.046z",
    "data-name": "Fill 3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-2",
    transform: "translate(.001 13.329)",
    d: "M0 0v22.686h30.433V0z",
    "data-name": "Clip 4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-2",
    transform: "translate(31.291)",
    d: "M24.213 35.622V0H0v35.622z",
    "data-name": "Clip 7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-1",
    transform: "translate(31.291)",
    d: "M10.447 35.622h-3.5a5.591 5.591 0 0 1-1.913-.447 4.952 4.952 0 0 1-1.559-1.093A6.712 6.712 0 0 1 1.753 29.8h15.384l.022-1.187a15.674 15.674 0 0 0-.683-4.81 10.006 10.006 0 0 0-2.049-3.635 8.85 8.85 0 0 0-3.251-2.3 11.163 11.163 0 0 0-4.243-.768 11.071 11.071 0 0 0-3.839.64A9.141 9.141 0 0 0 0 19.656v-5.917A18.459 18.459 0 0 1 .752 8.39a13.252 13.252 0 0 1 2.213-4.366A10.479 10.479 0 0 1 11.53 0h12.684v19.624a23.5 23.5 0 0 1-.941 6.971 13.09 13.09 0 0 1-2.715 4.921c-2.31 2.559-5.712 3.94-10.111 4.106zm1.6-9.94H2.084A5.957 5.957 0 0 1 2.789 24 5.1 5.1 0 0 1 3.9 22.736a4.864 4.864 0 0 1 1.443-.806 5.091 5.091 0 0 1 1.7-.28 5.015 5.015 0 0 1 3.234 1.008 5.518 5.518 0 0 1 1.769 3.024z",
    "data-name": "Fill 6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eem-logo-2",
    transform: "translate(31.291)",
    d: "M24.213 35.622V0H0v35.622z",
    "data-name": "Clip 7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEemLogo);
export default __webpack_public_path__ + "static/media/eemLogo.fe95ea82ab677c1276a7f1c77967b527.svg";
export { ForwardRef as ReactComponent };